import BaseButton from "@common/components/Button/Button";
import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import { vars } from "@common/styles";
import styled from "styled-components";

export const Container = styled.div<{ $noPaddingBottom?: boolean }>`
  border-radius: 2rem;
  border: 1px solid ${vars.colors.grey90};
  padding: 2rem;
  text-align: center;
`;

export const Header = styled(Heading)`
  border-bottom: 1px solid ${vars.colors.grey100};
  margin-left: 1rem;
  display: flex;
  align-items: start;
  padding-bottom: 2rem;
`;

export const IconContainer = styled.div`
  margin-top: 4rem;
  margin-bottom: 4rem;
  display: flex;
  justify-content: space-around;

  & > * {
    height: 8rem;
    width: 8rem;
    border: 1px solid ${vars.colors.grey100};
    padding: 1rem;
    border-radius: 2rem;
  }
`;

export const Icon = styled.div``;

export const Title = styled(Heading)`
  height: 4rem;
  margin-top: 3rem;
  margin-bottom: 1rem;
`;

export const Subtitle = styled(Paragraph)`
  white-space: nowrap;
  margin-bottom: 1rem;
`;

export const Permission = styled.div`
  padding-bottom: 2rem;
  & > * {
    margin: auto;
    height: 5rem;
    background-color: transparent;
    color: ${vars.colors.white};
    border-left: 1px solid ${vars.colors.purple};
    border-right: 1px solid ${vars.colors.purple};
    border-bottom: 1px solid ${vars.colors.purple};
    padding-left: 2rem;
    display: flex;
    flex-wrap: wrap;
    align-content: space-around;
    justify-content: space-between;
  }

  & > :first-child {
    border: 1px solid ${vars.colors.purple};
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  & > :last-child {
    border: 1px solid ${vars.colors.purple};
    border-top: none;
    border-bottom-left-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-content: space-around;
  justify-content: space-between;
  height: 8rem;
  border-top: 1px solid ${vars.colors.grey100};
`;

export const Button = styled(BaseButton)`
  width: 7.5rem;
  height: 4.2rem;
  margin-left: 1.6rem;
`;

export const CancelButton = styled(BaseButton)`
  width: 7.5rem;
  height: 4.2rem;
  margin-left: 0.8rem;
`;
